'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'floppy-disk-pen';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e182';
var svgPathData = 'M128.1 32c-35.3 0-64 28.7-64 64l0 320c0 35.3 28.7 64 64 64l152.6 0 4.5-22.5c3.2-15.8 9.6-30.6 18.9-43.5-5.1 1.3-10.5 2-16.1 2-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 4.6-.5 9.1-1.4 13.4L486.1 229.9c7.8-7.8 16.6-14.2 25.9-19l0-37.7c0-17-6.7-33.3-18.7-45.3L416.1 50.7c-12-12-28.3-18.7-45.3-18.7L128.1 32zm32 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64zM332.3 467l-11.9 59.6c-.2 .9-.3 1.9-.3 2.9 0 8 6.5 14.6 14.6 14.6 1 0 1.9-.1 2.9-.3l59.6-11.9c12.4-2.5 23.8-8.6 32.7-17.5l118.9-118.9-80-80-118.9 118.9c-8.9 8.9-15 20.3-17.5 32.7zM600.1 344c22.1-22.1 22.1-57.9 0-80s-57.9-22.1-80 0l-28.8 28.8 80 80 28.8-28.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDiskPen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;